export const onboarding = {
  // Maximum number of core contracts to be displayed in the top 'core' contracts table.
  CORE_LIMIT: 8,
  ELECTIVE_MIN_LIMIT: 11,
  ELECTIVE_MAX_LIMIT: 12,
  SIG_AGENT_REQUIRED: 8,
  CAREER_REQUIRED: 8,
  ASSOC_REQUIRED: 5,
  AFFILIATE_REQUIRED: 1,
  ENABLE_CORE_AUTO_SELECT: true,
  MAX_EXTERNAL_CARRIERS: 3,
  LAST_CONTRACT_VIEW_META_KEY: 'contracting---last-active-view',
}

// Per-usertype contracting configuration.
//   min       - required # of signed/started core|preferred contracts to advance.
//   max.core  - # of core contracts displayed in the top 'core' table.
//   max.electiveMin / max.elective - elective carrier min/max limits.
//   max.external - max external (non-priority) carriers an agent may add.
export const usertypeContracting = {
  signature: {
    min: onboarding.SIG_AGENT_REQUIRED,
    max: {
      core: onboarding.CORE_LIMIT,
      electiveMin: onboarding.ELECTIVE_MIN_LIMIT,
      elective: onboarding.ELECTIVE_MAX_LIMIT,
      external: onboarding.MAX_EXTERNAL_CARRIERS,
    },
  },
  career: {
    min: onboarding.CAREER_REQUIRED,
    max: {
      core: onboarding.CORE_LIMIT,
      electiveMin: onboarding.ELECTIVE_MIN_LIMIT,
      elective: onboarding.ELECTIVE_MAX_LIMIT,
      external: onboarding.MAX_EXTERNAL_CARRIERS,
    },
  },
  associate: {
    min: onboarding.ASSOC_REQUIRED,
    max: {
      core: onboarding.CORE_LIMIT,
      electiveMin: onboarding.ELECTIVE_MIN_LIMIT,
      elective: onboarding.ELECTIVE_MAX_LIMIT,
      external: onboarding.MAX_EXTERNAL_CARRIERS,
    },
  },
  affiliate: {
    min: onboarding.AFFILIATE_REQUIRED,
    max: {
      core: onboarding.CORE_LIMIT,
      electiveMin: onboarding.ELECTIVE_MIN_LIMIT,
      elective: onboarding.ELECTIVE_MAX_LIMIT,
      external: onboarding.MAX_EXTERNAL_CARRIERS,
    },
  },
}

// Resolve the contracting usertype key for the current user. Pass
// UserProfileService.isA so this module stays dependency-free.
export const getContractingUsertype = isA => {
  if (isA(['affiliate-group'])) return 'affiliate'
  if (isA(['associate-group'])) return 'associate'
  if (isA(['career-agent'])) return 'career'
  return 'signature'
}

// Resolve the full contracting config (min + max) for the current user.
export const getUsertypeContracting = isA =>
  usertypeContracting[getContractingUsertype(isA)] || usertypeContracting.signature

export const cart = {
  resetter: {
    permitted: ['internal-staff', 'internal-admin', 'system-admin'],
    destructive: {
      permitted: ['internal-staff', 'internal-admin', 'system-admin'],
    },
  },
}

export default {
  onboarding,
  usertypeContracting,
  getContractingUsertype,
  getUsertypeContracting,
  cart,
}
